import userStore from "./userStore";
import loadingStore from "./loadingStore";

const store = { userStore, loadingStore };
export default store;
